import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {useUserCity} from 'modules/locations/hooks/useUserCity';
import Icon from 'components/Icon';
import {HTMLProps} from 'react';
import classNames from 'classnames';

interface IProps extends HTMLProps<HTMLDivElement> {}

export const FooterLocation = ({className}: IProps) => {
    const title = useUserCity()?.title;

    if (!title) {
        return null;
    }

    return (
        <div className={classNames(style.footerLocation, className)}>
            <Icon className={style.icon} icon={'location-reverse'} />
            <Typography className={style.text} variant={'p'}>
                {title}
            </Typography>
        </div>
    );
};
